import { IsNotEmpty, IsNumber, IsEnum } from 'class-validator';

export enum resolutionTypes {
    s = 's',
    m = 'm',
    h = 'h',
    d = 'd',
    w = 'w',
    mo = 'mo',
    y = 'y'
}

export enum queryMethods {
    raw = 'raw',
    sum = 'sum',
    min = 'min',
    max = 'max',
    median = 'median',
    mean = 'mean'
}

export class QueryParametersDto {
    @IsNotEmpty()
    @IsNumber()
    resolution: number = 15;

    @IsNotEmpty()
    @IsEnum(resolutionTypes)
    resolutionType: resolutionTypes = resolutionTypes.m;

    @IsNotEmpty()
    @IsEnum(queryMethods)
    method: queryMethods = queryMethods.raw;
}
